export const categories = [
  {
    slug: 'qinggan-qingsu',
    name: '情感倾诉',
    description: '分享你的情感故事，倾听他人的心声，在这里找到理解与共鸣',
    icon: 'ri-heart-line',
    color: 'rose',
    count: 2846,
  },
  {
    slug: 'shenghuo-gushi',
    name: '生活故事',
    description: '记录生活中的点滴美好，平凡日子里的不平凡故事',
    icon: 'ri-book-open-line',
    color: 'amber',
    count: 3102,
  },
  {
    slug: 'tongcheng-jiaoyou',
    name: '同城交友',
    description: '在同一个城市遇见志同道合的朋友，线下活动与聚会',
    icon: 'ri-map-pin-line',
    color: 'emerald',
    count: 1753,
  },
  {
    slug: 'xinling-chengzhang',
    name: '心灵成长',
    description: '自我探索与内在成长，成为更好的自己',
    icon: 'ri-plant-line',
    color: 'teal',
    count: 2098,
  },
  {
    slug: 'jiating-guanxi',
    name: '家庭关系',
    description: '亲子、夫妻、婆媳，家庭关系中的温暖与智慧',
    icon: 'ri-home-heart-line',
    color: 'orange',
    count: 1667,
  },
  {
    slug: 'zhichang-rensheng',
    name: '职场人生',
    description: '职场经验、职业规划、工作与生活的平衡之道',
    icon: 'ri-briefcase-line',
    color: 'indigo',
    count: 1924,
  },
];

export const categoryMap: Record<string, typeof categories[number]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});